<template>
    <div>
        <b-button variant="info" :to="dataUrl" v-bind:class="{ 'mb-2': isMarginBottom, 'float-right': isRight, 'float-left': isLeft }" title="Create New Data"><font-awesome-icon icon="plus"/></b-button>
        <div v-if="clearfix" class="clearfix"/>
    </div>
</template>

<script>
  export default {
    props: {
      dataUrl: {
        type: String,
        required: true
      },
      clearfix: {
        type: Boolean,
        required: false,
        default: false
      },
      isMarginBottom: {
        type: Boolean,
        required: false,
        default: true
      },
      isRight: {
        type: Boolean,
        required: false,
        default: true
      },
      isLeft: {
        type: Boolean,
        required: false,
        default: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Buttons/CreateNewData.vue